import { useFeatureValue } from "@growthbook/growthbook-react"
import { InputProps, SelectInput } from "react-admin"

import { EntryTypeChoices } from "../../constants"

export const SelectEntryTypeInput: React.FC<InputProps> = (props) => {
  const hideLegacySeasons = useFeatureValue("ui:hide-legacy-seasons", false)

  const choices = hideLegacySeasons
    ? EntryTypeChoices.filter((choice) => choice.id !== "season")
    : EntryTypeChoices

  return <SelectInput {...props} choices={choices} />
}
